<template>
  <div class="err_x">
    <img class="err_img" src="../../assets/IMG/404.png" />
    <div>
      <p class="txt_title">可能的原因：</p>
      <p class="txt_msg">您访问的页面地址有误，或者该页面不存在</p>
      <p class="txt_msg">您没有该页面的相关权限</p>
      <p class="txt_title" style="margin-top: 16px">建议您：</p>
      <p class="txt_msg">请检查您访问的网址是否正确</p>
      <p class="txt_msg">
        <span>请检查您的账号权限</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Error404",
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style scoped>
.err_x {
  margin: 0 10px;
  display: flex;
  flex-flow: column wrap;
  align-items: center;
  width: auto;
  height: 94%;
  font-size: 18px;
  background: #fff;
  border-radius: 4px;
}
.err_img {
  margin-top: 30px;
  margin-bottom: 30px;
  width: 450px;
  height: 293px;
}
.txt_title {
  font-weight: bold;
  line-height: 24px;
  color: #3e3a39;
}
.txt_msg {
  text-indent: 2em;
  font-weight: 400;
  margin-top: 4px;
}
.txt_home {
  margin-left: 10px;
  color: #b7282d;
  text-decoration: underline;
  cursor: pointer;
}
</style>